var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.84136 10.353C0.537927 10.7395 0.587642 11.3137 0.951076 11.6363C1.31451 11.9589 1.85537 11.9061 2.15795 11.5196L6.44372 6.96261C6.478 6.91978 6.49429 6.86874 6.52 6.82134C6.54058 6.78398 6.56458 6.75117 6.58001 6.71015C6.61943 6.60352 6.64258 6.49233 6.64258 6.37931C6.64258 6.2663 6.61943 6.15511 6.58001 6.04847C6.56458 6.00746 6.54058 5.97465 6.52 5.93728C6.49429 5.88989 6.478 5.83885 6.44372 5.79601L2.15795 1.23899C1.85537 0.851647 1.31451 0.799696 0.951075 1.12233C0.587642 1.44406 0.537927 2.01824 0.841359 2.40559L3.9554 5.46791L4.81248 6.37923L3.95332 7.29276L0.84136 10.353Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.01e94557a76de6c543afda905a2e2f0a.svg";
export { ForwardRef as ReactComponent };